<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.financialInformation.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">財務情報（売上・粗利・経常利益）</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>売上高</th>
              <td><span class="human-capitalt-data-table__text"><strong><span v-if="financialInformation.achievementSales!=null">{{financialInformation.achievementSales}} {{this.unit}}</span><span v-else> --- {{this.unit}}</span></strong></span></td>
            </tr>
            <tr>
              <th>粗利</th>
              <td><span class="human-capitalt-data-table__text"><strong><span v-if="financialInformation.achievementGrossProfit!=null">{{financialInformation.achievementGrossProfit}} {{this.unit}}</span><span v-else> --- {{this.unit}}</span></strong></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
                <th>経営利益</th>
              <td><span class="human-capitalt-data-table__text"><strong><span v-if="financialInformation.achievementOrdinaryProfit!=null">{{financialInformation.achievementOrdinaryProfit}} {{this.unit}}</span><span v-else> --- {{this.unit}}</span></strong></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(financialInformation.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(financialInformation.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->
</template>

<script>
//import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
//    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    financialInformation: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '千円',
    }
  },
  watch: {
    financialInformation() {
      this.inputFinancialInformation();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFinancialInformation() {
      this.$emit("change-financial-info-detail", {
        financialInformation: this.financialInformation,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
